exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-success-page .v-dialog>.v-card>.v-card__title{background-color:white !important}.auth-success-page .test-success-warning{justify-content:center}\n", ""]);

// exports
